import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

let productList = document.querySelectorAll('[js-product-list]');
if(productList.length > 0) {
    var swiper = new Swiper('[js-product-list]', {
        slidesPerView: 1.5,
        centeredSlides: false,
        spaceBetween: 0,
        grabCursor: false,
        // pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true,
        // },
        // navigation: {
        //     nextEl: '.swiper-next',
        //     prevEl: '.swiper-prev',
        // },
        breakpoints: {
            // when window width is >= 320px
            576: {
                slidesPerView: 2
            },
            // when window width is >= 480px
            768: {
                slidesPerView: 3
            },
            // when window width is >= 640px
            992: {
                slidesPerView: 4
            },
            1400: {
                slidesPerView: 5
            },
        },
    });
}

var swiperNext = document.querySelector('[swiper-next]');
var swiperPrev = document.querySelector('[swiper-prev]');

if (swiperNext) {
    swiperNext.addEventListener('click', function(e){
        e.preventDefault();
        swiper.slideNext(300);
        document.querySelector('[swiper-prev]').classList.remove('disabled');
        if(swiper.isEnd) {
            this.classList.add('disabled');
        }
        else if(this.classList.contains('disabled')){
            this.classList.remove('disabled');
        }
    });
}

if (swiperPrev) {
    swiperPrev.addEventListener('click', function (e) {
        e.preventDefault();
        swiper.slidePrev(300);
        document.querySelector('[swiper-next]').classList.remove('disabled');
        if (swiper.isBeginning) {
            this.classList.add('disabled');
        } else if (this.classList.contains('disabled')) {
            this.classList.remove('disabled');
        }
    });
}
